import { CSSProperties, useEffect, useState } from "react";

export default (boxWraps?: any[]): [string[], any] => {
    const [classes, setClasses] = useState<any[]>([]);
    const [styles, setStyles] = useState<CSSProperties>();

    const boxWrap = boxWraps?.[0] && boxWraps.length > 0 ? boxWraps[0] : undefined;

    useEffect(() => {
        if (boxWrap) {
            const tmpStyles = {};
            const tmpClasses = [];

            // Background Color
            if (boxWrap?.content?.backgroundColor) {
                tmpClasses.push("has_box_wrap");
            }

            if (boxWrap.content?.backgroundColor) {
                tmpStyles["--box-wrap-background-color"] = boxWrap.content.backgroundColor;
            }

            // Opacity
            if (boxWrap.content?.backgroundOpacity) {
                tmpStyles["--box-wrap-background-opacity"] = boxWrap.content.backgroundOpacity;
            }

            // Spacing
            if (boxWrap.content?.spacing) {
                tmpClasses.push(`spacing_${boxWrap.content.spacing}`);
            }

            // Border Radius
            if (boxWrap.content._contentType === "nestedBoxWrap2") {
                tmpClasses.push("radius_Rounded");
            }

            // Shadow
            if (boxWrap.content?.showShadow) {
                tmpClasses.push("show_shadow");
            }

            setClasses(tmpClasses);
            setStyles(tmpStyles);
        }
    }, [boxWrap]);

    return [classes, styles];
};